import React, { useEffect, useRef } from "react";
import { Layout } from "../../components";
import useBridgeServicesStyles, { BridgeServicesClasses } from "./styles";
import DownloadIconBuilder from "../../components/DownloadIconBuilder";
import { useTranslation } from "react-i18next";
import { servicesData } from "../../translation";
import {
  AppleStoreWhiteIcon,
  PlayStoreWhiteColorIcon,
  ArrowRightWhiteIcon,
  HomeIcon,
  ArrowTopIcon,
  AndroidIconWhite,
} from "../../assets/img/svgicons";
import { Link } from "react-router-dom";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export type BridgeServicesProps = {};

function BridgeServices(props: any) {
  // Access Url Path Parameters
  const { id } = props.match.params;
  // Translation
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  // Services Data
  const servicesDataEn: any = servicesData.en;
  const servicesDataTr: any = servicesData.tr;

  let [activeServices, setActiveServices] = React.useState(servicesDataEn);
  let [activeSliderImage, setActiveSliderImage] = React.useState();
  let [activeSliderItem, setActiveSliderItem] = React.useState(1);
  let [activeRoute, setActiveRoute] = React.useState("");
  let [serviceImageLoaded, setServiceImageLoaded] = React.useState(false);
  let [routeService, setRouteService] = React.useState(id);
  let [
    headerImageBackgroundColor,
    setHeaderImageBackgroundColor,
  ] = React.useState("");
  let [mobileMode, setMobileMode] = React.useState(false);

  let width = window.innerWidth;
  let breakpoint = 768;

  // Styles Hook Calling
  const useStyles: BridgeServicesClasses = useBridgeServicesStyles({
    serviceImageLoaded,
    headerImageBackgroundColor,
    mobileMode,
  });

  const setPlaceholderBackgroundPerServices = (id: any) => {
    switch (id) {
      case "prepaid":
        setHeaderImageBackgroundColor("#cb4634");
        break;
      case "travel":
        setHeaderImageBackgroundColor("#257272");
        break;
      case "bill-payment":
        setHeaderImageBackgroundColor("#cb4634");
        break;
      case "game-pin":
        setHeaderImageBackgroundColor("#1b1464");
        break;
      // case "wallet":
      //   setHeaderImageBackgroundColor("#ba244c");
      //   break;
      // case "qr-payment":
      //   setHeaderImageBackgroundColor("#257272");
      //   break;
      default:
        break;
    }
  };

  const backToTopRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    document.title = "SuperPay";
    window.scrollTo(0, 0);
    if (width <= breakpoint) {
      setMobileMode(true);
    }
    if (backToTopRef && backToTopRef.current) {
      // back to top
      let backToTopAnimation = gsap.timeline({
        scrollTrigger: {
          trigger: backToTopRef.current,
          start: "0 150px",
          end: "bottom bottom",
          toggleActions: "pause play pause reverse",
        },
      });
      backToTopAnimation.from(backToTopRef.current, {
        x: 500 + 100,
        duration: 1.2,
        opacity: 0,
      });
    }
  }, [width, breakpoint]);

  const prevServiceRoute = usePrevious(routeService);
  function usePrevious(value: any) {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);
    return ref.current;
  }

  const selectCurrentServiceHandler = (id: any, servicesData: any) => {
    let defaultTitle = "SuperPay - ";
    switch (id) {
      case "prepaid":
        setActiveServices(servicesData.prepaid);
        setActiveRoute(t("prepaidService"));
        setRouteService(id);
        setPlaceholderBackgroundPerServices(id);
        document.title = defaultTitle + t("prepaidService");
        break;
      case "travel":
        setActiveServices(servicesData.travel);
        setActiveRoute(t("travelService"));
        setRouteService(id);
        setPlaceholderBackgroundPerServices(id);
        document.title = defaultTitle + t("travelService");
        break;
      case "bill-payment":
        setActiveServices(servicesData.billPayment);
        setActiveRoute(t("billPaymentService"));
        setRouteService(id);
        setPlaceholderBackgroundPerServices(id);
        document.title = defaultTitle + t("billPaymentService");
        break;
      case "game-pin":
        setActiveServices(servicesData.gamePin);
        setActiveRoute(t("gamePinService"));
        setRouteService(id);
        setPlaceholderBackgroundPerServices(id);
        document.title = defaultTitle + t("gamePinService");
        break;
      // case "wallet":
      //   setActiveServices(servicesData.superpayWallet);
      //   setActiveRoute(t("walletService"));
      //   setRouteService(id);
      //   setPlaceholderBackgroundPerServices(id);
      //   document.title = defaultTitle + t("walletService");
      //   break;
      // case "qr-payment":
      //   setActiveServices(servicesData.qrPayment);
      //   setActiveRoute(t("qrCodeService"));
      //   setRouteService(id);
      //   setPlaceholderBackgroundPerServices(id);
      //   document.title = defaultTitle + t("qrCodeService");
      //   break;
      default:
        break;
    }
  };

  const mounted = useRef();
  useEffect(() => {
    if (!mounted.current) {
      if (routeService !== prevServiceRoute) {
        window.scrollTo(0, 0);
        setServiceImageLoaded(false);
        setActiveSliderItem(1);
        if (activeServices && activeServices.steps) {
          setActiveSliderImage(activeServices.steps[0].img);
        }
      }

      if (lang === "en") {
        selectCurrentServiceHandler(id, servicesDataEn);
      } else {
        selectCurrentServiceHandler(id, servicesDataTr);
      }
    }
  }, [
    routeService,
    prevServiceRoute,
    lang,
    id,
    servicesDataEn,
    servicesDataTr,
  ]);

  const checkFullLoadedImgService = () => {
    setTimeout(() => {
      setServiceImageLoaded(true);
    }, 300);
  };

  const selectActiveImageSlider = (id: any) => {
    let element = activeServices.steps.find((data: any) => {
      return data.id === id;
    });
    setActiveSliderImage(element.img);
    setActiveSliderItem(id);
  };
  const goToTopPageHandler = () => {
    window.scroll({ top: 0, behavior: "smooth" });
  };

  const downloadAppDirectlyHandler = (url: string) => {
    window.open(url);
  };

  return (
    <React.Fragment>
      <Layout>
        <button
          onClick={goToTopPageHandler}
          className={useStyles.backToTopPage}
          ref={backToTopRef}
        >
          <ArrowTopIcon width="18" style={{ opacity: "0.8" }} />
        </button>
        <section className={useStyles.mainSection}>
          <div className={useStyles.mainContainer}>
            <div className={useStyles.headerServicesContent}>
              <div className={useStyles.headerServicesContentContainer}>
                <div className={useStyles.headerServicesRouteContainer}>
                  <div className={useStyles.headerServicesRouteBox}>
                    <Link to="/">
                      <HomeIcon width="20" />
                    </Link>
                    <ArrowRightWhiteIcon style={{ margin: "0 10px" }} />
                    <span className={useStyles.headerServicesRouteText}>
                      {activeRoute}
                    </span>
                  </div>
                </div>
                <div className={useStyles.headerServicesContentBox}>
                  <h2 className={useStyles.headerServicesContentTitle}>
                    {activeServices.title}
                  </h2>
                  <p className={useStyles.headerServicesContentDesc}>
                    {activeServices.text}
                  </p>
                </div>
                {/* <div className={useStyles.headerServicesDownloadBox}>
                  <div className={useStyles.headerServicesDownloadLabel}>
                    {t("downloadNowText")}
                  </div>
                  <div className={useStyles.headerServicesDownloadLinks}>
                    <DownloadIconBuilder
                      link="#"
                      icon={<PlayStoreWhiteColorIcon width="28" height="34" />}
                      descText={"GET IN THE"}
                      descTextSize="9px"
                      mainText={"GooglePlay"}
                      mainTextSize="18px"
                      padding="10px 26px 10px 14px"
                      border="solid 1px white"
                    />
                    <div
                      className="divider"
                      style={
                        width <= breakpoint
                          ? { width: "5px" }
                          : { width: "10px" }
                      }
                    ></div>
                    <DownloadIconBuilder
                      link="#"
                      icon={<AppleStoreWhiteIcon width="26" height="34" />}
                      descText={"Available on the"}
                      descTextSize="9px"
                      mainText={"App Store"}
                      mainTextSize="18px"
                      padding="10px 43px 10px 14px"
                      border="solid 1px white"
                    />
                    <div
                      className="divider"
                      style={
                        width <= breakpoint
                          ? { width: "5px" }
                          : { width: "10px" }
                      }
                    ></div>
                    <DownloadIconBuilder
                      link="#"
                      icon={<AndroidIconWhite width="28" height="34" />}
                      descText={"Directly Download"}
                      descTextSize="9px"
                      mainText={"For Free"}
                      mainTextSize="18px"
                      padding="10px 49px 10px 14px"
                      border="solid 1px white"
                    />
                  </div>
                </div> */}
              </div>
            </div>
            <img
              src={activeServices.img}
              onLoad={checkFullLoadedImgService}
              className={useStyles.headerImage}
              alt=""
            />
          </div>
        </section>
        <section>
          <h3 className={useStyles.serviceStepTitle}>
            {activeServices.stepsTitle}
          </h3>
        </section>
        <section>
          <div className={useStyles.detailsServicesContainer}>
            <div className={useStyles.detailsServicesWrapper}>
              <div className={useStyles.detailsServicesBox}>
                <div className="detailsServicesDynamicSlide">
                  <img
                    src={
                      activeSliderImage
                        ? activeSliderImage
                        : activeServices && activeServices.steps
                        ? activeServices.steps[0].img
                        : ""
                    }
                    alt=""
                    className={useStyles.detailsServicesDynamicSlideImg}
                  />
                </div>
                <div className="detailsServicesItemsBox">
                  <ul className={useStyles.detailsServicesListItems}>
                    {activeServices && activeServices.steps
                      ? activeServices.steps.map((data: any, i: any) => {
                          return (
                            <li
                              className={useStyles.detailsServicesItem}
                              key={i}
                              onMouseEnter={() =>
                                selectActiveImageSlider(data.id)
                              }
                            >
                              <div
                                className={`${
                                  useStyles.detailsServicesItemContent
                                } ${
                                  activeSliderItem === data.id
                                    ? useStyles.activeSlide
                                    : ""
                                }`}
                              >
                                <div>
                                  <aside
                                    className={
                                      useStyles.detailsServicesItemNumber
                                    }
                                  >
                                    {data.id}
                                  </aside>
                                </div>
                                <div>
                                  <p
                                    className={
                                      useStyles.detailsServicesItemText
                                    }
                                  >
                                    {data.value}
                                  </p>
                                </div>
                              </div>
                            </li>
                          );
                        })
                      : ""}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </React.Fragment>
  );
}

export default BridgeServices;
